<template>
    <ModalComponent
        name="add-sale-ad"
        title="Añadir aviso de ventas"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="editarSaleAd()">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Email" type="email" name="email" rules="required|email" v-model="data.email" />
                </div>
                <div class="col-12 col-lg-12">
                    <div class="form-group">
                        <label for="intervalo">Intervalo de tiempo:</label>
                        <select v-model="data.time_lapse" id="intervalo" name="intervalo" class="form-control">
                            <template v-for="(intervalo, index) in intervalos">
                                <option :key="index" :value="intervalo.valor">{{ intervalo.name }}</option>
                            </template>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="submit-sale-ad">Continuar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['evento_id'],
        data() {
            return {
                data: {
                    time_lapse: 0,
                    event_id: this.evento_id
                },
                intervalos: [
                    { name: '12 horas', valor: 0 },
                    { name: '24 horas', valor : 1 },
                    { name: '48 horas',  valor : 2 },
                    { name: '72 horas', valor : 3 },
                    { name: '1 semana', valor : 4 },
                    { name: '2 semanas', valor : 5 }
                ]
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'add-sale-ad', editado);
            },
            editarSaleAd() {
                this.data.filters = {};
                this.data.evento_id = this.evento_id;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sales-ad.crear'), this.data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                    this.loading = false;
                });
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
